// extracted by mini-css-extract-plugin
export default {"wutong":"index_wutong_uWfqd"};